module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10",
      "offset": "1"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_STUDENT_MANAGEMENT_TITLE', this.lang)))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10",
      "offset": "1"
    }
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDown,
      "variant": "success"
    },
    on: {
      "dismissed": function($event) {
        _vm.dismissCountdown = 0
      },
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_vm._v("\n         " + _vm._s(this.successMessage) + "\n        ")]), _vm._v(" "), _c('v-client-table', {
    ref: "studentsTable",
    attrs: {
      "data": _vm.studentsData,
      "columns": _vm.studentsColumns,
      "options": _vm.studentsOptions
    },
    scopedSlots: _vm._u([{
      key: "editStudent",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.studentRowClick(props)
            }
          }
        })
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "effect": "fade",
      "title": this.editBoxTitle
    },
    on: {
      "shown": _vm.setModalInputFocus
    },
    model: {
      value: (_vm.editStudent),
      callback: function($$v) {
        _vm.editStudent = $$v
      },
      expression: "editStudent"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.showMissingData
    }
  }, [_vm._v("    \n        " + _vm._s(_vm.$t('LNG_STUDENT_MISSING_DATA', this.lang)) + "\n    ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.showErrorMessage
    }
  }, [_vm._v("    \n        " + _vm._s(this.errorMessage) + "\n    ")]), _vm._v(" "), _c('b-input', {
    ref: "studentFirstname",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_STUDENT_FIRSTNAME', this.lang)
    },
    model: {
      value: (_vm.studentFirstname),
      callback: function($$v) {
        _vm.studentFirstname = $$v
      },
      expression: "studentFirstname"
    }
  }), _vm._v(" "), _c('b-input', {
    ref: "studentName",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_STUDENT_NAME', this.lang)
    },
    model: {
      value: (_vm.studentName),
      callback: function($$v) {
        _vm.studentName = $$v
      },
      expression: "studentName"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectSexe.options,
      "size": "sm"
    },
    model: {
      value: (_vm.selectSexe.value),
      callback: function($$v) {
        _vm.$set(_vm.selectSexe, "value", $$v)
      },
      expression: "selectSexe.value"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectEntity.options,
      "size": "sm"
    },
    model: {
      value: (_vm.selectEntity.value),
      callback: function($$v) {
        _vm.$set(_vm.selectEntity, "value", $$v)
      },
      expression: "selectEntity.value"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "multiple": "",
      "select-size": 4,
      "options": _vm.selectGroup.options
    },
    model: {
      value: (_vm.selectGroup.value),
      callback: function($$v) {
        _vm.$set(_vm.selectGroup, "value", $$v)
      },
      expression: "selectGroup.value"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitEditStudent()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveEditStudent($event)
      }
    }
  }, [_vm._v(_vm._s(this.btnSaveStudent))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe3536e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/managementStudentsGroups.vue
// module id = 881
// module chunks = 1